/* ============
 * The initial state of the delegate module.
 * ============
 */
export default {
  isDelegatesLoading: false,
  delegates: [],
  totalCount: 0
};
